module.exports = __webpack_public_path__ + "static/img/tu-3.8947b1f8.png";